export default {"src":"/_next/static/media/not-found.57797411.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};